import React, {Component} from 'react';
import { FormControl } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
// import TextFieldModal from 'component/element/TextFieldModal'
import PrintPreview from '../PrintPreview';
import PdfStore from 'stores/PdfStore';

var NotificationSystem = require('react-notification-system');
class PrintSSTWarrantyWorkDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:{car:{car_registration_no:'',brand:'',model:''},pdf_config:{extra_remark:''},
      insurer:{insurer_id:'',insurer_name:''},
      receiving:{entrance_date:'',entrance_name:'',title:'',entrance_name_as:'',tel:''},
      driver:{},owner:{}}
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  loadData() {
    let {workNo} = this.props
    let that = this
    this.setState({ loading: true })
    PdfStore.loadWarrantyworkDoc(workNo,function(result) {
      let data = result.data
      that.setState({loading:false,data:data})
    })  
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderComponentPage() {
    let {data} = this.state
    let {mode,title} = this.props
    let {receiving,car,insurer,driver,owner,delivering} = data
    return(
      <div className='font-print'>
        <header>
          <h2 className="text-right">{mode==='2'?'ใบรับรถไม่จอดซ่อม':title}</h2>
        </header>  
        <article className={"article-company "+data.logo_class}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-20" style={{paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} ({data.company_branch})</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>
            </strong>
          </section>
        </article>
        <br/>
        <br/>
        <div className='box-sst-parking-car-doc'>
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left'>
                  ชื่อพนักงาน <span style={{width:'200px',borderBottom:'2px dotted #111',display:'inline-block'}}>{delivering?(delivering.delivered_by?delivering.delivered_by:<br />):<br />}</span> &nbsp;
                  โทร. <span style={{width:'200px',borderBottom:'2px dotted #111',display:'inline-block'}}>{delivering?(delivering.tel?delivering.tel:<br />):<br />}</span>
                </td>
              </tr>
            </tbody>
          </table>  
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left'>
                  ประกันรถ <span style={{width:(insurer.insurer_name?'auto':'120px'),borderBottom:'2px dotted #111',display:'inline-block'}}>{insurer?(insurer.insurer_name?insurer.insurer_name:<br />):<br />}</span> &nbsp;
                  ยี่ห้อ <span style={{width:'90px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car?(car.brand?car.brand:<br />):<br />}</span> &nbsp;
                  รุ่น <span style={{width:'90px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car?(car.model?car.model:<br />):<br />}</span> &nbsp;
                  สี <span style={{width:'70px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car?(car.car_color?car.car_color:<br />):<br />}</span> &nbsp;
                </td>
              </tr>
            </tbody>  
          </table>
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left' style={{position:'relative'}}>
                  ชื่อ(เจ้าของรถ) <span style={{width:'120px',borderBottom:'2px dotted #111',display:'inline-block'}}>{owner?(owner.first_name?owner.first_name:<br />):<br />}</span> &nbsp;
                  นามสกุล <span style={{width:'120px',borderBottom:'2px dotted #111',display:'inline-block'}}>{owner?(owner.last_name?owner.last_name:<br />):<br />}</span> &nbsp;
                  ทะเบียน <span style={{width:'120px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car?(car.car_registration_no?car.car_registration_no:<br />):<br />}</span>
                </td>
              </tr>
            </tbody>  
          </table>
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left' style={{position:'relative'}}>
                  เลขตัวถัง <span style={{width:'200px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car?(car.chassis_no?car.chassis_no:<br />):<br />}</span> &nbsp;
                  เลขไมล์ <span style={{width:'200px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car?(car.mileage?car.mileage:<br />):<br />}</span>
                </td>
              </tr>
            </tbody>  
          </table>
          <div style={{fontSize:'26px'}} className='text-red'>
            เงื่อนไขการรับประกัน บริษัทศูณย์สีทรัพย์ทวี จํากัด
          </div>  
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left'>1. รับประกันคุณภาพงานการทำสี เป็นระยะเวลา 6 เดือน</td>
              </tr>
              <tr>
                <td className='text-left'>2. การรับประกันจะครอบคลุมถึงแค่ สีหลุด ลอก ด้าน</td>
              </tr>
              <tr>
                <td className='text-left'>อันเกิดจากการทำงานของทางอู่เท่านั้น</td>
              </tr>
              <tr>
                <td className='text-left'>3. ใบรับประกันถือเป็นเอกสารสำคัญ ห้ามทำหาย หรือ ฉีกขาด</td>
              </tr>
              <tr>
                <td className='text-left'>และจะต้องไม่มีการขีดเขียน เปลี่ยนแปลง แก้ไขใดๆ ทั้งสิ้น</td>
              </tr>
              <tr>
                <td className='text-left'>4. เครื่องยนต์และช่วงล่าง รับประกัน 2 สัปดาห์</td>
              </tr>              
            </tbody>  
          </table>  
          <div style={{display:'flex',marginTop:'50px'}}>
            <div style={{width:'15%'}}></div>
            <div style={{width:'33%'}}>
              <div className='box-sst-sg'>
                <table className='table table-sst-parking-car-doc-footer' style={{marginBottom:'0'}}>
                  <tbody>
                    <tr>
                      <td className='text-center'>ผู้ส่งมอบ........................................</td>
                    </tr>
                    <tr>
                      <td className='text-center'>วันที่............/............/............</td>
                    </tr>
                  </tbody>
                </table>
              </div>  
            </div>
            <div style={{width:'4%'}}></div>
            <div style={{width:'33%'}}>
              <div className='box-sst-sg'>
                <table className='table table-sst-parking-car-doc-footer' style={{marginBottom:'0'}}>
                  <tbody>
                    <tr>
                      <td className='text-center'>ผู้รับรถ........................................</td>
                    </tr>
                    <tr>
                      <td className='text-center'>วันที่............/............/............</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{width:'15%'}}></div>
          </div>
        </div>
      </div>
    )
  }
  
  render() {
    let {loading} = this.state
    let {mode,title} = this.props
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={title}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}  

PrintSSTWarrantyWorkDoc.defaultProps = {
  title: 'ใบรับประกันงานซ่อมสี'
}
export default PrintSSTWarrantyWorkDoc;        


// WEBPACK FOOTER //
// ./src/view/print/sst/PrintSSTWarrantyWorkDoc.js